import { useMemo } from 'react';
import { DemeterMarket, UnitOfMeasure } from '../../../../Generated/Raven-Demeter';
import useLanguage from '../../../Services/Language/useLanguageHook';
import { TrackingEvent } from '../../../Services/Tracking/TrackingService';
import useMarketCommoditySelection from '../../Navigation/Hooks/useMarketCommoditySelectionHook';
import Dropdown from './Dropdown';

type UnitOfMeasureDropdownOptionsType = { label: string; value: UnitOfMeasure };

interface IUnitOfMeasureMetricImperialDropdownProps {
    unitOfMeasure?: UnitOfMeasure;
    handleChange: (value: UnitOfMeasure | undefined) => void;
    testId?: string | undefined;
    track: TrackingEvent;
}

const UnitOfMeasureMetricImperialDropdown: React.FC<IUnitOfMeasureMetricImperialDropdownProps> = (
    props: IUnitOfMeasureMetricImperialDropdownProps,
): JSX.Element => {
    const [translations] = useLanguage();
    const marketByCommodity = useMarketCommoditySelection();
    const dropdownEnabled = useMemo(() => marketByCommodity === DemeterMarket.Dairy, [marketByCommodity]);

    const unitOfMeasureDropdownOptions = useMemo(
        () => [
            {
                label: translations.dropdown.nativeUnits,
                value: undefined,
            },
            {
                label: translations.unitOfMeasure[UnitOfMeasure.Imperial],
                value: UnitOfMeasure.Imperial,
            },
            {
                label: translations.unitOfMeasure[UnitOfMeasure.Metric],
                value: UnitOfMeasure.Metric,
            },
        ],
        [translations],
    ) as UnitOfMeasureDropdownOptionsType[];

    return (
        <Dropdown
            value={dropdownEnabled ? props.unitOfMeasure : undefined}
            options={unitOfMeasureDropdownOptions}
            handleOptionChange={(value: UnitOfMeasure | undefined) => props.handleChange(value)}
            disabled={!dropdownEnabled}
            testId={props.testId}
            track={props.track}
        />
    );
};

export default UnitOfMeasureMetricImperialDropdown;
